module.exports = __webpack_public_path__ + "img/ic_wanchengrenzheng.c212a4f5.svg";